































































































































































































































































































































































































































































































































































import DragUpload from '@/components/util/DragUpload.vue';
import DetailLayout from '@/components/system/DetailsLayout.vue';
import FloorPicker from '@/components/system/FloorPicker.vue';
import Location2Picker from '@/components/system/Location2Picker.vue';
import CampusPicker from '@/components/system/CampusPicker.vue';
import ContactPicker from '@/components/system/ContactPicker.vue';
import ScrollIntoView from '@/services/ScrollIntoView';
import { Component, Vue, Watch } from 'vue-property-decorator';
import {
  SystemApi,
  WorkordersApi,
  UsersApi,
  Workorder,
  User as PmoUser,
  ValidationProblemDetails,
  Property,
  PerformoSettings,
  JobType,
  Contact,
  Building,
  FieldMetadata,
  ValueListItem
} from 'performo-api';
import { mapGetters } from 'vuex';
import ExtendedDataPicker from '@/components/system/ExtendedDataPicker.vue';

@Component({
  components: {
    DragUpload,
    DetailLayout,
    FloorPicker,
    Location2Picker,
    CampusPicker,
    ContactPicker,
    ExtendedDataPicker
  },
  computed: mapGetters({
    currentProperty: 'currentProperty',
    settings: 'settings'
  })
})
export default class Create extends Vue {
  private sys = new SystemApi(this.$store.getters.getApiConfiguration);
  private usersApi = new UsersApi(this.$store.getters.getApiConfiguration);
  private currentProperty!: Property;
  private settings!: PerformoSettings;

  private departments: ValueListItem[] = [];

  private showContactPicker = false;
  private selectedContact: Contact = {};
  private submitDisabled = false;

  // used to pass picked contact location data into the location pickers.
  // these values are "sticky" in the location pickers,
  // so that they persist across the triggered api calls and loading.
  private intendedLocationData: Contact = {};

  hasPhoto = false;
  currentPerformoUserAndContact: PmoUser = { contact: {} };
  createdOrderId? = '';

  get currentUserName(): string {
    return this.$store.getters.userDisplayName;
  }
  get currentPropertyId(): string {
    return this.$store.getters.currentPropertyId;
  }
  get allowReqCreate(): boolean {
    if (!this.settings.requireProfileForRequests) return true;
    if (!this.settings.requiredProfileAttributes) return true;
    // Check the contact has a value for every required attribute
    const result = this.settings.requiredProfileAttributes.every((attr) => {
      if (!this.currentPerformoUserAndContact.contact) return false;
      // https://stackoverflow.com/questions/56833469/typescript-error-ts7053-element-implicitly-has-an-any-type/56833507#56833507
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const contact: { [index: string]: any } =
        this.currentPerformoUserAndContact.contact;
      return contact[attr] ? true : false;
    });
    return result;
  }
  get floorLabel(): string {
    return this.currentProperty.floorLabel
      ? this.currentProperty.floorLabel
      : 'Floor';
  }

  private createOrderWatcher = false;
  private order!: Workorder; // = {};
  private validationProblems: ValidationProblemDetails = {};
  private customFields: FieldMetadata[] = [];

  // this lets the undefined order! refs become reactive
  // https://class-component.vuejs.org/guide/class-component.html#data
  data() {
    return {
      order: {
        campus: undefined,
        building: undefined,
        floor: undefined,
        suite: undefined,
        trade: undefined,
        jobType: undefined,
        extendedData: undefined
      } as Workorder
    };
  }

  private async mounted() {
    this.currentPerformoUserAndContact = await this.usersApi.getMyProfile();
    const wkoApi = new WorkordersApi(this.$store.getters.getApiConfiguration);
    this.customFields = await wkoApi.getCustomFields();
    await this.configureLocationData();
  }

  private async getDepartments() {
    if (this.currentPropertyId) {
      this.departments = await this.sys.getValueListItems({
        propertyId: this.currentPropertyId,
        name: 'Department'
      });
      // set the default value to the user's department if it exists
      const departmentName =
        this.currentPerformoUserAndContact.contact?.departmentName;
      const matchingDepartment = this.departments.find(
        (d) => d.valueListValue === departmentName
      );
      if (matchingDepartment) {
        this.order.orderByField2 = departmentName;
      }
    }
  }

  private async configureLocationData() {
    // we use the current user's contact data to populate the location pickers with default values
    if (
      this.currentPerformoUserAndContact &&
      this.currentPerformoUserAndContact.contact &&
      this.currentPerformoUserAndContact.contact.propertyId ===
        this.currentPropertyId
    ) {
      if (this.settings.enableCampuses) {
        this.intendedLocationData.campus =
          this.currentPerformoUserAndContact.contact.campus;
      }
      this.intendedLocationData.location1 =
        this.currentPerformoUserAndContact.contact.location1;
      this.intendedLocationData.location2 =
        this.currentPerformoUserAndContact.contact.location2;
      this.intendedLocationData.floor =
        this.currentPerformoUserAndContact.contact.floor;
    }

    if (this.settings.allowRequestersToSetWorkorderDepartment) {
      await this.getDepartments();
    }

    if (this.settings.disableLocationPickersForRequesters) {
      // the location pickers are disabled for requesters, so we have to set the order values manually here
      this.order = {
        ...this.order,
        campus: this.intendedLocationData.campus,
        building: this.intendedLocationData.location1,
        floor: this.intendedLocationData.floor,
        suite: this.intendedLocationData.location2
      };
    }
  }

  private photoSuccessHandler() {
    if (this.createdOrderId) {
      this.$router.push({
        name: 'work-order-detail',
        params: { id: this.createdOrderId.toString() }
      });
    }
  }

  private async successHandler(order: Workorder) {
    // update with our newly minted work order
    this.createdOrderId = order.workorderId?.toString();

    // add any queued photos
    // if a file is attached, we have to use the upload er to do the upload as well as the form submission
    // otherwise we hit the api directly.
    if (this.hasPhoto) {
      // await nextTick, since we need the prop passed dragupload to update before we process the queue
      await this.$nextTick();

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (this.$refs.dragUpload as any).processUploadQueue();
    }

    if (order && order.workorderId) {
      // if we have a photo, the success handler will redirect, if not we redirect here.
      if (!this.hasPhoto) {
        this.$router.push({
          name: 'work-order-detail',
          params: { id: order.workorderId }
        });
      }
    }
  }

  private async errorHandler(error: ValidationProblemDetails | Response) {
    if (!error) {
      return;
    }

    if (error instanceof Response) {
      error = await error.json();
    }

    this.validationProblems = error;

    // scroll the error div into view on a delay
    setTimeout(() => {
      ScrollIntoView('error-display');
    }, 100);

    // since there was an error, re-enable the submit button to allow the user to try again
    this.submitDisabled = false;
  }

  private fileAddedHandler() {
    this.hasPhoto = true;
  }

  @Watch('currentPropertyId', { immediate: true })
  private async propertyIdChanged(newPropertyId: string) {
    this.order.propertyId = newPropertyId;
    if (this.settings.allowRequestersToSetWorkorderDepartment) {
      await this.getDepartments();
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private extendedDataPickedHandler(newExtendedData: { [key: string]: any }) {
    this.order.extendedData = newExtendedData;
  }

  private async jobTypePickedHandler(pickedJobType: JobType) {
    this.order.trade = pickedJobType.trade;
  }

  private async createRequest() {
    this.submitDisabled = true;
    // attach propertyId at create time.
    this.order.propertyId = this.currentPropertyId;

    const wkoApi = new WorkordersApi(this.$store.getters.getApiConfiguration);
    wkoApi
      .createRequest({ workorderCreateCommand: this.order })
      .then(this.successHandler, this.errorHandler)
      .finally(() => {
        // empty
      });
  }

  private toggleContactPicker() {
    if (this.showContactPicker) {
      this.order.contactId = null;
      this.selectedContact = {};
      this.showContactPicker = false;
    } else {
      this.showContactPicker = true;
    }
  }

  private updateSelectedContact(contact: Contact) {
    if (contact) {
      this.selectedContact = contact;

      // set this because we want the order location details to match the contact's
      this.intendedLocationData = contact;
    } else {
      this.selectedContact = {};
    }
  }

  private buildingPickedHandler(pickedBuilding: Building) {
    if (this.settings.enableCampuses) {
      this.order.campus = pickedBuilding.campusName;

      // updating order.campus may trigger the building picker to load new building values
      // we set the intended location data here to persist the building value
      this.intendedLocationData.location1 = pickedBuilding.buildingCode;
    }
  }
}
